import { IMapState } from '../types';

export function selectIsFirstMapInteraction(state: IMapState): boolean {
  return state.map.isFirstMapInteraction;
}
